@if (model$ | async; as model) {
  <div class="product-results">
    <div class="results-header">
      <div>
        <h1 class="results-title" id="resultsTitle">
          @if (model?.breadcrumbs?.length) {
            {{ model.breadcrumbs[0].facetValueName }} ({{ model?.pagination?.totalResults || 0 }})
          }
        </h1>
        <p class="results-count" [innerHTML]="getPageTitle(model) | async"></p>
      </div>

      <div class="sort-container">
        <div class="sort-container">
          <label class="sort-label">{{ 'label.sortBy' | cxTranslate }}:</label>
          <div class="sort-dropdown p-0">
            <cx-sorting
              [sortOptions]="model.sorts"
              (sortListEvent)="sortList($event)"
              [selectedOption]="model.pagination?.sort"
              [ariaLabel]="'productList.sortResults' | cxTranslate"
              ariaControls="product-results-list"
              placeholder="{{ 'productList.sortBy' | cxTranslate }}">
            </cx-sorting>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="results-header justify-content-between">
        <kn-br-active-facet></kn-br-active-facet>
      </div>

      @if (viewMode$ | async; as viewMode) {
        <div class="p-res-right-0">
          <div class="cx-sorting top">
            <div class="row">
              @if (!isInfiniteScroll) {
                <div class="col-auto">
                  <div class="cx-pagination" aria-label="product search pagination">
                    <cx-pagination
                      [pagination]="model.pagination"
                      queryParam="currentPage"
                      [defaultPage]="0">
                    </cx-pagination>
                  </div>
                </div>
              }
            </div>
          </div>

          <div>
            @if (!isInfiniteScroll) {
              @if (viewMode === ViewModes.Grid) {
                <div class="select-all position-fixed p-3 right-0 color-knbr-primary">
                  <div
                    class="
                      remember-me
                      custom-control
                      col-md-12
                      float-left
                      d-flex
                      justify-content-start
                      cursor-pointer
                      p-0
                    ">
                    <div class="form-check custom-checkbox mb-0 m-0">
                      <input type="checkbox" class="custom-control-input rounded" id="default" />
                      <label class="custom-control-label text-light font-size" for="default">
                        {{ 'productList.label.selectAll' | cxTranslate }}
                      </label>
                    </div>
                  </div>
                </div>

                @for (product of model?.products; track $index) {
                  <kn-br-product-grid-item
                    [product]="product"
                    class="col-12 col-sm-6 col-md-4">
                  </kn-br-product-grid-item>
                }
              }

              @if (viewMode === ViewModes.List) {
                <div class="select-all position-fixed p-3 right-0 color-knbr-primary">
                  <div
                    class="
                      remember-me
                      custom-control
                      col-md-12
                      float-left
                      d-flex
                      justify-content-start
                      cursor-pointer
                      p-0
                    ">
                    <div class="form-check custom-checkbox mb-0 m-0">
                      <input type="checkbox" class="custom-control-input rounded" id="default" />
                      <label class="custom-control-label text-light font-size" for="default">
                        {{ 'productList.label.selectAll' | cxTranslate }}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="customersearch-list-table product-res-titles float-left col-lg-12 pr-0">
                  <div class="customersearch-list-titles border-top float-left w-100 p-3">
                    <div class="col-md-4 text-center padding-res-0 float-left font-text-600">
                      {{ 'productList.label.name' | cxTranslate }}
                    </div>
                    <div class="col-md-1 text-center float-left font-text-600">
                      {{ 'productList.label.id' | cxTranslate }}
                    </div>
                    <div class="col-md-2 text-center float-left font-text-600">
                      {{ 'productList.label.netPrice' | cxTranslate }}
                    </div>
                    <div class="col-md-2 text-center float-left font-text-600">
                      {{ 'productList.label.listPrice' | cxTranslate }}
                    </div>
                    <div class="col-md-1 text-center float-left font-text-600">
                      {{ 'productList.label.uom' | cxTranslate }}
                    </div>
                    <div class="col-md-1 text-center float-left font-text-600">
                      {{ 'productList.label.moq' | cxTranslate }}
                    </div>
                    <div class="col-md-1 text-center float-left font-text-600"></div>
                  </div>

                  @for (product of model?.products; track $index) {
                    <kn-br-product-list-item
                      [product]="product">
                    </kn-br-product-list-item>
                  }
                </div>
              }
            } @else {
              <kn-br-product-scroll
                [scrollConfig]="scrollConfig"
                [model]="model"
                [inputViewMode]="viewMode">
              </kn-br-product-scroll>
            }

            @if (!model?.products?.length) {
              <div class="no-products" id="noProducts">
                <div class="no-products-icon">📦</div>
                <h3>{{ 'productList.label.noProductFound' | cxTranslate }}</h3>
                <p>{{ 'productList.label.tryNewFilterSearch' | cxTranslate }}</p>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}